import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import Chart from 'chart.js/auto';
@Component({
  selector: 'app-department-service',
  templateUrl: 'department-service.component.html',
  styleUrls: ['department-service.component.scss']
})

export class DepartmentService implements OnInit, OnChanges {
  @ViewChild('department') department: ElementRef<HTMLCanvasElement> | any;
  @ViewChild('service') service: ElementRef<HTMLCanvasElement> | any;
  public departmentChart: Chart | any;
  public serviceChart: Chart | any;
  public chart: Chart | any;
  public departmentData: any;
  public serviceData: any = [];
  public label = [];
  @Input() config: any;
  @Input() data: any;
  
  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void { 
    this.label = [
    this.translate.instant('dashboardLang.state'),
    this.translate.instant('dashboardLang.center')
    ]
  }

  ngAfterViewInit(): void {
    this.serviceChart = new Chart(this.service.nativeElement, {
      type: 'doughnut',
      data: {
        labels: this.label,
        datasets: [{
          label: 'Services',
          data: [],
          backgroundColor: [
           '#00599F',
           '#f38600'
          ]
        }]
      },
      options: {
        responsive: true,
        scales: {
        },
        plugins: {
          legend: {
            display: false
          }
        }
      }
    });
  }

  ngOnChanges(){
    this.updateData();
  }
  
  updateData() {
    setTimeout(()=>{
      if (this.data && this.serviceChart) {
        this.serviceChart.data.datasets[0].data = [this.data?.stateServiceCount,this.data?.centerServiceCount];
        this.serviceChart.update();
      }
    },0)
  }

}